import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import VueGtag from "vue-gtag";

// const isProd = process.env.Node_ENV === "production";

Vue.config.productionTip = false
Vue.use(VueGtag, {
    config: {id: "UA-140529184-1"},
    enabled: true

}, router);

Vue.directive('scroll', {
    inserted: function (el, binding) {
        let f = function (evt) {
            if (binding.value(evt, el)) {
                window.removeEventListener('scroll', f)
            }
        }
        window.addEventListener('scroll', f)
    }
})

router.beforeEach((to, from, next) => {
    if (to.path === '/work/6' || to.path === '/work/5') next({path: 'works'})
    // else if (to.path === '/feature/0') next({path: '/'})
    else next()
})

new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app')
